import dayjs, { Dayjs } from "dayjs";

export const DEFAULT_FINANCE_REPORT_AUTO_REFRESH_MAX_AGE_MS =
  60 * 60 * 1000;

export const createFinanceReportPeriod = (
  year: number,
  month: number,
): Dayjs => dayjs(new Date(year, month, 1));

export const getFinanceReportAutoRefreshMaxAgeMs = (
  envValue = process.env.REACT_APP_FINANCE_REPORT_AUTO_REFRESH_MAX_AGE_MS,
): number => {
  const parsed = Number(envValue);

  if (!Number.isFinite(parsed) || parsed <= 0) {
    return DEFAULT_FINANCE_REPORT_AUTO_REFRESH_MAX_AGE_MS;
  }

  return parsed;
};

export const shouldAutoRefreshFinanceReport = ({
  selectedPeriod,
  monthlyReportLastChangedAt,
  now = dayjs(),
  maxAgeMs = getFinanceReportAutoRefreshMaxAgeMs(),
}: {
  selectedPeriod: Dayjs;
  monthlyReportLastChangedAt?: number;
  now?: Dayjs;
  maxAgeMs?: number;
}): boolean => {
  const isCurrentPeriod =
    selectedPeriod.year() === now.year() &&
    selectedPeriod.month() === now.month();

  if (!isCurrentPeriod) {
    return false;
  }

  if (!Number.isFinite(monthlyReportLastChangedAt)) {
    return true;
  }

  const lastChangedAtMs = Number(monthlyReportLastChangedAt) * 1000;

  return now.valueOf() - lastChangedAtMs > maxAgeMs;
};
